module.exports = __webpack_public_path__ + "static/media/mp.0eb597a0.jpg";